/* FB RECETA — lo poco que la receta necesita de JavaScript.
   Tres cosas, ninguna imprescindible: si el archivo no carga, la página
   sigue siendo una receta legible.

     1. Palomear ingredientes mientras se cocina. Es de sesión: no se
        guarda nada ni se manda a ningún lado.
     2. La barra pegajosa aparece al dejar atrás la foto.
     3. El botón de imprimir.

   Se engancha por delegación desde el contenedor, así que sirve igual
   para el cuerpo v2 (que arma el tema) y para el v1 (que viene tal cual
   del admin de Shopify). */
(function () {
  var raiz = document.querySelector('[data-fb-receta]');
  if (!raiz) return;

  var quieto = window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function normaliza(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /* --- 0. las notas del chef, en su propia hoja -----------------------
     En el texto del artículo las notas son hermanos sueltos: el último
     <h2> y todo lo que le sigue. Para que se vean como una hoja de papel
     —chueca, con renglones, con su cinta— tienen que estar dentro de una
     caja, y una caja no se puede crear desde CSS. Se crea aquí.

     Si el artículo no tiene al menos dos <h2> no hay una "sección final"
     que valga la pena aislar, y no se toca nada. */
  (function () {
    var cuerpo = raiz.querySelector('.rc-v2');
    if (!cuerpo || !cuerpo.querySelectorAll) return;
    var titulos = cuerpo.querySelectorAll(':scope > h2');
    if (titulos.length < 2) return;
    var ultimo = titulos[titulos.length - 1];
    var hoja = document.createElement('div');
    hoja.className = 'rc-notas';
    cuerpo.insertBefore(hoja, ultimo);
    while (hoja.nextSibling) hoja.appendChild(hoja.nextSibling);
  }());

  /* --- 0a. el cuerpo que se quedó atrapado en el bloque de tiempos -----
     En cuatro de las heredadas —chuleta de cerdo, chicharrón, brochetas de
     róbalo y hotateyaki— el editor viejo metió TODO el cuerpo, ingredientes
     y pasos, DENTRO del <div> de los tiempos, como un hijo más.

     La hoja convierte cada hijo de ese bloque en una píldora, que es lo
     correcto para un dato de dos palabras y un desastre para una receta
     entera: salía encimada sobre los pasos. No se arregla con CSS a secas
     porque las orillas del bloque —las dos líneas— acabarían abrazando la
     receta completa. Aquí se saca del bloque y se deja justo después, en
     el mismo orden. El texto no se toca: solo cambia de lugar. */
  (function () {
    var cuerpo = raiz.querySelector('.rc-v1');
    if (!cuerpo || !cuerpo.querySelectorAll) return;
    var bloques = cuerpo.querySelectorAll(':scope > div');
    Array.prototype.forEach.call(bloques, function (bloque) {
      Array.prototype.slice.call(bloque.children).forEach(function (hijo) {
        /* un dato es un renglón; si trae secciones o listas es el cuerpo */
        if (!hijo.querySelector || !hijo.querySelector('section, ul, ol, h1, h2, h3')) return;
        var tras = bloque;
        while (hijo.firstChild) {
          tras.parentNode.insertBefore(hijo.firstChild, tras.nextSibling);
          tras = tras.nextSibling;
        }
        hijo.parentNode.removeChild(hijo);
      });
    });
  }());

  /* --- 0b. la tira de ingredientes entra por turnos -------------------- */
  var piezas = raiz.querySelectorAll('.rc-mise__i');
  for (var q = 0; q < piezas.length; q++) {
    piezas[q].style.setProperty('--rc-i', q);
  }

  /* --- 1. ingredientes palomeables ------------------------------------
     Solo las <li> que están dentro de la tarjeta de ingredientes. En v1
     no hay tarjeta propia, así que se toman las <li> de la primera <ul>
     del cuerpo, que es siempre la de ingredientes. */
  var listas = raiz.querySelectorAll('.rc-v2 ul, .rc-v1 ul');

  var palomear = function (li) {
    /* un subtítulo no se palomea: no es un ingrediente */
    if (li.classList.contains('rc-ing-titulo')) return;
    var on = li.classList.toggle('rc-hecho');
    li.setAttribute('aria-checked', on ? 'true' : 'false');
  };

  /* El mismo dibujo de la tira de arriba, en chico, junto a su renglón.
     El enganche va por la palabra clave que trae cada ilustración (`k`) y
     no por parecido de textos: "Chile poblano" no es subcadena de
     "6 chiles poblanos asados", pero "poblano" sí. Los renglones que no
     casan con nada —el pan molido, la manta de cielo— reciben un hueco
     vacío del mismo ancho para que el texto de todos arranque en la misma
     vertical. */
  var ilustraciones = [];
  try {
    var caja = raiz.querySelector('[data-rc-ilustraciones]');
    if (caja) ilustraciones = JSON.parse(caja.textContent) || [];
  } catch (e) { ilustraciones = []; }

  /* La clave tiene que casar con una PALABRA, no con un trozo de palabra:
     buscando "agua" a secas, "aguacate" salía con un vaso de agua al lado.
     Se permite el plural al final —"chile" casa con "chiles poblanos",
     "poblano" con "poblanos"— y nada más. */
  function casa(texto, clave) {
    if (!clave) return false;
    var c = normaliza(clave).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('\\b' + c + '(es|s)?\\b').test(texto);
  }

  /* Hay listas con subtítulos adentro: "Salsa verde:", "Alioli de ajo:",
     "Guacamole:". Son renglones de la <ul> pero no son ingredientes, así
     que no se palomean ni se ilustran — si no, "Alioli de ajo:" se lleva
     el dibujo del ajo y el diente de ajo de abajo se queda sin nada. */
  function esTitulo(texto) {
    var t = texto.trim();
    return /:$/.test(t) || /^ingredientes\b/.test(normaliza(t));
  }

  /* Gana la clave MÁS LARGA que case, no la primera del arreglo: así
     "limon amarillo" le gana a "limon" y "nuez moscada" a "nuez" sin que
     el orden del metafield tenga que andar cuidándolo. Y un mismo dibujo
     puede repetirse: una receta por secciones nombra el ajo en la salsa
     verde y otra vez en la roja, y las dos veces toca ajo. */
  function ilustra(li) {
    var texto = normaliza(li.textContent);
    var elegida = null, mejor = 0;
    for (var k = 0; k < ilustraciones.length; k++) {
      var i = ilustraciones[k];
      if (!i.k || i.k.length <= mejor) continue;
      if (casa(texto, i.k)) { elegida = i; mejor = i.k.length; }
    }
    var nodo;
    if (elegida && elegida.u) {
      nodo = document.createElement('img');
      nodo.className = 'rc-ing-ilu';
      nodo.src = elegida.u;
      nodo.alt = '';
      nodo.setAttribute('aria-hidden', 'true');
      nodo.loading = 'lazy';
    } else {
      nodo = document.createElement('span');
      nodo.className = 'rc-ing-ilu rc-ing-ilu--vacia';
      nodo.setAttribute('aria-hidden', 'true');
    }
    li.insertBefore(nodo, li.firstChild);
  }

  /* El encabezado de la sección a la que pertenece la lista — el <h3> que
     dice "Ingredientes". Se busca hacia atrás desde la <ul> y, si no, desde
     su <section>, que es como vienen armadas las heredadas. */
  function encabezadoDe(lista) {
    var n = lista;
    while (n && n !== raiz) {
      var p = n.previousElementSibling;
      while (p) {
        if (/^H[1-4]$/.test(p.tagName)) return p.textContent;
        p = p.previousElementSibling;
      }
      n = n.parentNode;
    }
    return '';
  }

  Array.prototype.forEach.call(listas, function (lista) {
    var encabezado = normaliza(encabezadoDe(lista)).trim();

    Array.prototype.forEach.call(lista.children, function (li) {
      if (esTitulo(li.textContent)) {
        var clases = 'rc-ing-titulo';
        /* "Ingredientes" repetido palabra por palabra debajo del <h3> que ya
           lo dice: no aporta nada, se esconde. Uno que agregue algo —
           "Ingredientes (para 2 a 3 porciones)"— sí se queda. */
        if (encabezado && normaliza(li.textContent).trim() === encabezado) {
          clases += ' rc-ing-titulo--mudo';
        }
        li.className = (li.className ? li.className + ' ' : '') + clases;
        return;
      }
      li.setAttribute('role', 'checkbox');
      li.setAttribute('aria-checked', 'false');
      li.setAttribute('tabindex', '0');
      if (ilustraciones.length) ilustra(li);
    });

    lista.addEventListener('click', function (e) {
      /* una liga dentro del ingrediente gana: es navegación, no palomeo */
      if (e.target.closest('a')) return;
      var li = e.target.closest('li');
      if (li && li.parentNode === lista) palomear(li);
    });

    lista.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var li = e.target.closest('li');
      if (li && li.parentNode === lista) {
        e.preventDefault();
        palomear(li);
      }
    });
  });

  /* --- 1b. subtítulos dentro de los pasos ------------------------------
     Las heredadas traen la numeración ESCRITA en el texto —"1. ", "2. "— y
     quien las escribió numeró parejo los subtítulos y las instrucciones:
     "1. Prepara los chiles", "2. Limpia los chiles ancho…". La hoja esconde
     esa cifra y vuelve a numerar con un contador, así que reproducía el
     mismo error: doce pasos donde hay seis.

     Un subtítulo se reconoce por cómo está escrito: corto, sin punto final,
     sin coma y sin cifras — "Haz el adobo", "Preparar el alioli de ajo".
     Una instrucción de verdad casi siempre trae alguna de las tres
     ("Precalienta el horno a 180°C (350°F).").

     Al quitarle el <span> de la cifra el párrafo deja de casar con la regla
     del paso, así que sale del contador solo: no hay que pelear con el CSS,
     y la cuenta de abajo se corre sola. */
  var SINONIMOS_PASOS = ['pasos', 'instrucciones', 'preparacion', 'procedimiento'];

  function esTituloDePaso(t) {
    var s = (t || '').replace(/\s+/g, ' ').trim();
    if (!s || s.length >= 70) return false;
    if (/\.$/.test(s)) return false;
    return !/[,;:0-9]/.test(s);
  }

  Array.prototype.forEach.call(
    raiz.querySelectorAll('.rc-v1 section > p'),
    function (p) {
      var hijos = p.children;
      if (hijos.length !== 2) return;
      if (hijos[0].tagName !== 'SPAN' || hijos[1].tagName !== 'SPAN') return;
      if (!/^\s*\d+\s*\.\s*$/.test(hijos[0].textContent)) return;

      var texto = hijos[1].textContent;
      if (!esTituloDePaso(texto)) return;

      /* fuera la cifra: con un solo <span> el párrafo ya no es un paso */
      p.removeChild(hijos[0]);

      var clases = 'rc-paso-titulo';
      /* "Instrucciones" escrito debajo del <h3> que ya dice "Pasos": es la
         misma palabra dos veces, no un subtítulo. */
      var propio = normaliza(texto).trim();
      var seccion = normaliza(encabezadoDe(p)).trim();
      if (SINONIMOS_PASOS.indexOf(propio) > -1 &&
          SINONIMOS_PASOS.indexOf(seccion) > -1) {
        clases += ' rc-paso-titulo--mudo';
      }
      p.className = (p.className ? p.className + ' ' : '') + clases;
    }
  );

  /* --- 2. barra pegajosa ----------------------------------------------
     Se prende cuando el héroe sale de cuadro. IntersectionObserver para
     no escuchar el scroll; si el navegador no lo trae, la barra
     simplemente nunca aparece y no pasa nada. */
  var barra = raiz.querySelector('.rc-barra');
  var hero = raiz.querySelector('.rc-hero');
  if (barra && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      barra.classList.toggle('is-on', !entradas[0].isIntersecting);
    }, { rootMargin: '-70px 0px 0px 0px' }).observe(hero);
  }

  /* --- 2b. parallax del héroe -----------------------------------------
     La foto se mueve hacia abajo a una fracción de lo que baja la página,
     así que parece quedarse atrás. El tope es 14 % del alto del héroe, que
     es exactamente el sobrante que le da el CSS (alto 128 %, montada
     -14 %): más que eso y asomaría el borde.

     rAF para no calcular en cada evento de scroll, y nada de esto corre si
     el sistema pidió menos movimiento. */
  var foto = raiz.querySelector('.rc-hero__img');
  if (foto && hero && !quieto) {
    var pendiente = false;
    var correr = function () {
      pendiente = false;
      var alto = hero.offsetHeight || 1;
      var y = Math.min(window.pageYOffset || window.scrollY || 0, alto);
      foto.style.transform = 'translate3d(0,' + (y * 0.14).toFixed(1) + 'px,0)';
    };
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; window.requestAnimationFrame(correr); }
    }, { passive: true });
    correr();
  }

  /* --- 3. anclas ------------------------------------------------------
     Los saltos de la barra necesitan un id al cual brincar, y el texto
     del artículo viene sin ids (a propósito: el redactor no debería
     tener que ponerlos). Se los pone aquí, buscando el encabezado por
     lo que dice. Sirve igual para v2 (<h2>) que para v1 (<h3>).
     Si no aparece el encabezado, el salto se queda escondido. */
  var cuerpo = raiz.querySelector('.rc-cuerpo');
  if (cuerpo) {
    var encabezados = cuerpo.querySelectorAll('h2, h3');

    var anclar = function (busca, id, enlace) {
      for (var i = 0; i < encabezados.length; i++) {
        var t = (encabezados[i].textContent || '')
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        if (t.indexOf(busca) !== -1) {
          encabezados[i].id = id;
          encabezados[i].style.scrollMarginTop = '76px';
          if (enlace) enlace.hidden = false;
          return;
        }
      }
    };

    anclar('ingredient', 'rc-ing', raiz.querySelector('[data-rc-salto-ing]'));
    anclar('prepar', 'rc-prep', raiz.querySelector('[data-rc-salto-prep]'));
    if (!document.getElementById('rc-prep')) {
      anclar('paso', 'rc-prep', raiz.querySelector('[data-rc-salto-prep]'));
    }

    /* cada paso queda direccionable: es lo que declara el JSON-LD de
       Recipe en el `url` de cada HowToStep. */
    var pasos = cuerpo.querySelectorAll('ol > li');
    for (var j = 0; j < pasos.length; j++) {
      if (!pasos[j].id) pasos[j].id = 'paso-' + (j + 1);
    }
  }

  /* --- 4. sangrado a todo lo ancho -------------------------------------
     El CSS lo intenta con `margin-left: calc(50% - 50vw)`, que solo sale
     bien si el contenedor está centrado en la ventana. Deja de estarlo en
     cuanto algo le mete padding al body — el carrito acoplado le pone 144
     px a la derecha — y entonces la banda se pasa 72 px a la izquierda y
     se le corta la ruta de migas. La barra de desplazamiento hace lo
     mismo en chiquito.

     Aquí no se supone: se mide. Se quita el margen, se ve dónde nace el
     bloque, y ese número es exactamente lo que hay que jalar. El ancho
     disponible es el de la ventana menos lo que el body reserve.

     El CSS sigue siendo el valor de arranque, así que si este archivo no
     carga la página se ve bien en el caso normal. */
  /* La banda va del borde izquierdo de la página (que se recorre cuando el chat
     de Javi abre su columna) hasta donde termina el contenido del body (antes
     del carrito acoplado). */
  function sangrado() {
    raiz.style.marginLeft = '0px';
    raiz.style.width = 'auto';
    var pagina = document.documentElement.getBoundingClientRect().left;
    var cuerpo = document.body.getBoundingClientRect();
    var hasta = cuerpo.right - (parseFloat(getComputedStyle(document.body).paddingRight) || 0);
    var izq = raiz.getBoundingClientRect().left;
    raiz.style.marginLeft = (pagina - izq) + 'px';
    raiz.style.width = (hasta - pagina) + 'px';
  }
  sangrado();
  window.addEventListener('resize', sangrado);
  /* el carrito acoplado y el chat cambian el padding/margen con transición:
     se vuelve a medir cuando terminan, no solo cuando cambia la clase */
  var otraVez = null;
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      sangrado();
      clearTimeout(otraVez);
      otraVez = setTimeout(sangrado, 500);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  [document.documentElement, document.body].forEach(function (el) {
    el.addEventListener('transitionend', function (e) { if (e.target === el) sangrado(); });
  });

  /* --- 5. imprimir ----------------------------------------------------- */
  var imprimir = raiz.querySelector('[data-rc-imprimir]');
  if (imprimir) {
    imprimir.addEventListener('click', function () { window.print(); });
  }
}());
